import React from "react";
import {Link} from "react-router-dom";
import LoginButton from "../auth/LoginButton";
import {LoggedOutRoutes} from "../../LoggedOutRoutes";
import ExchangeDiagram from "./ExchangeDiagram";

export default function HomePage() {

  return (
      <React.Fragment>
        <section className="lo-hero">
          <div>
            <h1>Current, curated data for your Nzyme clusters.</h1>

            <p className="lead">
              Connect supplies your Nzyme setups with up-to-date reference data, from IP geolocation to device
              vendors, and keeps an eye on their health.
            </p>

            <div className="lo-hero-actions">
              <LoginButton className="btn btn-lg btn-primary" />
              <Link to={LoggedOutRoutes.HOWTO}>How to set it up</Link>
            </div>
          </div>

          <ExchangeDiagram />
        </section>
      </React.Fragment>
  )

}
